import { render } from "./DeanProgramOutcomes.vue?vue&type=template&id=6aaba78a"
import script from "./DeanProgramOutcomes.vue?vue&type=script&lang=js"
export * from "./DeanProgramOutcomes.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__